import { graphql, useStaticQuery } from 'gatsby';

export const alphabet = 'abcdefghijklmnopqrstuvwxyz'.split('');

const flattenTitles = ({ title, uri }: { title: { postTitle: { shortTitle: string; }; }; uri: string; }) => ({ title: title?.postTitle?.shortTitle, uri });

const normalizeString = (str: string) => str.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase();

const sortGlossaryPages = (pages: { title: string; uri: string; }[]) => {
  const sortedPages: {
    [letter: string]: { title: string; uri: string; }[];
  } = {};

  alphabet.forEach((letter) => {
    const letterPages = pages.filter(({ title }) => (Array.from(normalizeString(title))[0] === letter));
    sortedPages[letter] = letterPages;
  });

  return sortedPages;
};

export const useGlossaryPagesQuery = () => {
  const data = useStaticQuery(graphql`
    query GlossaryPagesQuery {
      allWpGlossaryPage(
        filter: {
          isCptFrontPage: {eq: false},
          templatesEditorial: {postTitle: {shortTitle: {ne: null}}}
        },
        sort: {title: ASC}
      ) {
        nodes {
          title: templatesEditorial {
            postTitle {
              shortTitle
            }
          }
          uri
        }
      }
    }
  `);

  const results = data?.allWpGlossaryPage?.nodes?.map(flattenTitles) || [];

  return {
    glossaryPages: results,
    sortedGlossaryPages: sortGlossaryPages(results),
  };
};
